import { render, staticRenderFns } from "./InsPromotion.vue?vue&type=template&id=3b7b2751&scoped=true&"
import script from "./InsPromotion.vue?vue&type=script&lang=ts&"
export * from "./InsPromotion.vue?vue&type=script&lang=ts&"
import style0 from "./InsPromotion.vue?vue&type=style&index=0&id=3b7b2751&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b7b2751",
  null
  
)

export default component.exports